import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  TextField,
  EditButton,
  TextInput,
  Filter,
} from "react-admin";
import OptimaKidzFileCustomInput from "./OptimaKidzFileCustomInput";

const OptimaKidzFileFilter = (props) => (
  <Filter {...props}>
    <TextInput source="title" alwaysOn/>
    <TextInput source="book_name" alwaysOn/>
  </Filter>
);

export const OptimaKidzFileList = props => (
  <List {...props} filters={<OptimaKidzFileFilter/>} filter={{is_published: true}}>
    <Datagrid>
      <TextField source="id"/>
      <TextField source="name"/>
      <TextField source="name_vi"/>
      <TextField source="order" label="Order point" />
      <TextField source="book_name"/>
      <EditButton basePath="/kidz-file"/>
    </Datagrid>
  </List>
);

export const OptimaKidzFileEdit = props => (
  <Edit {...props}>
    <OptimaKidzFileCustomInput/>
  </Edit>
);

export const OptimaKidzFileCreate = props => (
  <Create {...props}>
    <OptimaKidzFileCustomInput/>
  </Create>
);
